import React from 'react';
import TextField from 'material-ui/TextField';
import {viewStyles} from './styles-view';

/**
 * Set a field for form entry
 *
 * @param touched
 * @param error
 * @param inputProps
 * @param props
 * @return {*}
 */
export const renderTextInput = (
    {
        meta: {touched, error} = {},
        input: {...inputProps},
        ...props
    }) => {
    return (
        <TextField
            errorText={touched && error}
            {...inputProps}
            {...props}
            fullWidth
        />
    )
};

/**
 * Set a field for form entry
 *
 * @param {*} field
 * @returns
 */
export const renderDateInput = (field) => {
    return (
        <span>
			<input
                type="date"
                id={field.id}
                name={field.name}
                max={field.maxDate ? field.maxDate : undefined}
                min={field.minDate ? field.minDate : undefined}
                onChange={field.input.onChange ? field.input.onChange : undefined}
                placeholder={field.placeholder ? field.placeholder : undefined}
                required={field.required}
                value={field.inputValue ? field.inputValue : undefined}
                style={viewStyles.calendarInput}
            />
            {field.meta.touched && field.meta.error && (
                <span>{field.meta.error}</span>
            )}
		</span>
    );
};

/**
 * Validate an AOR select input
 *
 * @param value
 * @returns {boolean}
 */
export const validateRequiredSelect = (value) => {
    let error = false;
    if (!value) {
        error = true;
    }
    return error;
};


// WEBPACK FOOTER //
// ./src/Fuse/shared/formFunctions.js